/**
 * Smart Mini-Cart Drawer Interactive Script
 * Integrated into Jolie Home theme - Urbanwipe Sp
 */

(function () {
  // Helper to format money in Indian Rupees (INR)
  function formatINR(cents) {
    const amount = (cents / 100).toFixed(2);
    // Remove trailing .00 if needed, but standard is decimal
    return '₹' + parseFloat(amount).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // Helper to format integer money (no decimals)
  function formatINRInt(cents) {
    const amount = Math.round(cents / 100);
    return '₹' + amount.toLocaleString('en-IN');
  }

  // Toggles for drawers & accordions
  window.toggleSmartCartOrderSummary = function () {
    const container = document.querySelector('.sr-shopflo-billing-container');
    if (container) {
      container.classList.toggle('active');
    }
  };

  window.toggleInlineCoupon = function (headerEl) {
    const section = headerEl.closest('.sr-cart-toggle-section');
    if (section) {
      section.classList.toggle('active');
    }
  };

  window.toggleInlineNote = function (headerEl) {
    const section = headerEl.closest('.sr-cart-toggle-section');
    if (section) {
      section.classList.toggle('active');
    }
  };

  window.clickApplyCouponTag = function (code) {
    const input = document.getElementById('sr-cart-coupon-input-main');
    if (input) {
      input.value = code;
      window.handleCouponInputChange('sr-cart-coupon-input-main', 'sr-cart-coupon-input-action-main');
      window.couponApplyHandler('sr-cart-coupon-input-main');
    }
  };

  window.updateUpsellVariant = function (selectEl) {
    const wrapper = selectEl.closest('.similar-item-wrapper');
    if (!wrapper) return;
    
    const selectedOption = selectEl.options[selectEl.selectedIndex];
    const variantId = selectEl.value;
    const priceText = selectedOption.getAttribute('data-price');
    
    // Update the + Add button
    const addBtn = wrapper.querySelector('.sr-upsell-item-action');
    if (addBtn) {
      addBtn.setAttribute('data-variant-id', variantId);
      addBtn.setAttribute('onclick', `addUpsellToCart('${variantId}')`);
    }
    
    // Update the displayed price
    const priceEl = wrapper.querySelector('.sr-upsell-item-current-price');
    if (priceEl && priceText) {
      priceEl.innerText = priceText;
    }
  };

  // Close main mini-cart drawer
  window.closeMiniCartDrawerHandler = function (e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // Find the trigger button that opened this cart drawer and click it to run the native toggle flow
    const activePushSide = document.querySelector('.push_side.active, .push_side.act_current, [data-id="#js_cart_popup"].active, [data-id="#js_cart_popup"].act_current');
    if (activePushSide) {
      activePushSide.click();
      return;
    }

    // Trigger theme's native jQuery close events
    if (window.jQuery) {
      window.jQuery('.mask-overlay').trigger('click');
      window.jQuery('.close_popup_ajax').trigger('click');
    } else if (window.$) {
      window.$('.mask-overlay').trigger('click');
      window.$('.close_popup_ajax').trigger('click');
    }

    // Safely remove all cart open states manually as a fallback
    const html = document.documentElement;
    html.classList.remove('pside_opened', 'hside_opened', 'open_menu', 'open_show');

    const minicart = document.getElementById('js_cart_popup');
    if (minicart) {
      minicart.classList.remove('act_opened');
    }
    
    const mask = document.querySelector('.mask-overlay');
    if (mask) {
      mask.classList.remove('mask_opened');
    }
    
    // In case body holds the class in some themes
    document.body.classList.remove('pside_opened', 'hside_opened', 'open_show');
  };

  // Coupon Code input action enabled/disabled state
  window.handleCouponInputChange = function (inputId, actionId) {
    const input = document.getElementById(inputId);
    const action = document.getElementById(actionId);
    if (input && action) {
      if (input.value.trim().length > 0) {
        action.classList.remove('disabled');
      } else {
        action.classList.add('disabled');
      }
    }
  };

  // Coupon Code Apply handler
  window.couponApplyHandler = function (inputId) {
    const input = document.getElementById(inputId);
    if (!input) return;
    const code = input.value.trim().toUpperCase();
    if (!code) return;

    // Show full loader
    const loader = document.querySelector('.full-page-loader-container');
    if (loader) loader.style.display = 'flex';

    // Simulate validation and hook into Shopify Discount API
    setTimeout(function () {
      if (loader) loader.style.display = 'none';

      // We can apply any coupon code by setting local storage or pushing it to checkout
      localStorage.setItem('storedDiscount', code);
      
      // Update coupons in standard checkout form
      document.querySelectorAll('[name="discount"]').forEach(function (el) {
        el.value = code;
      });

      // Show success coupon alert box
      const successBox = document.getElementById('sr-cart-coupon-success');
      const couponNameEl = document.getElementById('sr-cart-applied-coupon-name');
      const couponAmtEl = document.getElementById('sr-cart-applied-coupon-amount');
      const errorBox = document.getElementById('sr-cart-coupon-error-main');

      if (successBox && couponNameEl && couponAmtEl) {
        couponNameEl.innerText = code;
        
        // Calculate a 10% coupon save amount or dynamic save based on cart total
        const cartScript = document.getElementById('json-data-cart');
        let saveVal = 150; // default savings
        if (cartScript) {
          try {
            const cartData = JSON.parse(cartScript.innerHTML);
            saveVal = Math.round((cartData.total_price * 0.1) / 100);
          } catch(e) {}
        }

        couponAmtEl.innerText = saveVal;
        successBox.classList.remove('hidden');
        if (errorBox) errorBox.classList.add('hidden');
        
        // Save savings in localStorage to add to price calculations
        localStorage.setItem('couponDiscountVal', saveVal * 100);
      }
      
      // Recalculate bill details immediately
      recalculateCartSmartState();
    }, 600);
  };

  // Delete item handler
  window.deleteMiniCartItemHandler = function (e) {
    if (e) e.preventDefault();
    const btn = e.currentTarget;
    const id = btn.getAttribute('data-id');
    
    // Directly delete the item
    updateCartItemQuantity(id, 0);
  };

  // Upsell addition handler
  window.addUpsellToCart = function (variantId) {
    const loader = document.querySelector('.full-page-loader-container');
    if (loader) loader.style.display = 'flex';

    // Add via AJAX
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Reload cart section to update drawer UI
      document.body.dispatchEvent(new Event('update:miniCart'));
    })
    .catch(err => {
      console.error(err);
      if (loader) loader.style.display = 'none';
    });
  };

  // Add notes to cart
  window.editSmartCartNoteHandler = function () {
    const input = document.getElementById('sr-cart-note-text-field');
    const saveBtn = document.getElementById('sr-cart-note-save-button');
    if (input && saveBtn) {
      if (input.value.trim().length > 0) {
        saveBtn.removeAttribute('disabled');
      } else {
        saveBtn.setAttribute('disabled', 'disabled');
      }
    }
  };

  window.handleAddNoteToCart = function (action) {
    const input = document.getElementById('sr-cart-note-text-field');
    if (!input) return;
    const note = input.value.trim();

    const loader = document.querySelector('.full-page-loader-container');
    if (loader) loader.style.display = 'flex';

    fetch(window.routes.cart_update_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        note: note
      })
    })
    .then(response => response.json())
    .then(data => {
      if (loader) loader.style.display = 'none';
      const noteToggleSection = document.getElementById('sr-cart-note-toggle-section');
      if (noteToggleSection) {
        noteToggleSection.classList.remove('active');
      }
    })
    .catch(err => {
      console.error(err);
      if (loader) loader.style.display = 'none';
    });
  };

  // Redirect to checkout with Applied Coupon (Supports Shiprocket Fastrr integration)
  window.handleSmartCartBuy = function (e) {
    const coupon = localStorage.getItem('storedDiscount');
    let checkoutUrl = '/checkout';
    if (coupon) {
      checkoutUrl += '?discount=' + encodeURIComponent(coupon);
    }

    // If Fastrr script is active on the page, let it handle the form submit and intercept
    if (window.Fastrr || window.fastrr || document.querySelector('.fastrr-popup') || document.querySelector('.fastrr-checkout-container') || document.getElementById('fastrr-sdk')) {
      return; // Handed off to Shiprocket Fastrr Checkout!
    }

    if (e) e.preventDefault();
    window.location.href = checkoutUrl;
  };

  // Main dynamic state calculations
  function recalculateCartSmartState() {
    const cartScript = document.getElementById('json-data-cart') || document.querySelector('.data-json-cart');
    if (!cartScript) return;
    
    let cart = null;
    try {
      cart = JSON.parse(cartScript.innerHTML);
    } catch (e) {
      console.error("Could not parse cart JSON", e);
      return;
    }

    if (!cart || !cart.items || cart.items.length === 0) {
      // Show empty state, hide normal wrapper
      const emptyContainer = document.querySelector('.mini-cart-empty-cart-container');
      const bodyWrapper = document.querySelector('.wrapper-mini-cart-sr');
      const footer = document.querySelector('.mini-cart-footer');
      if (emptyContainer) emptyContainer.classList.remove('hidden');
      if (bodyWrapper) bodyWrapper.classList.add('hidden');
      if (footer) footer.classList.add('hidden');
      return;
    }

    // Read schema configs from progress section attributes
    const progressSection = document.getElementById('mini-cart-progress-section');
    let m1Qty = 2, m1Price = 349, m2Qty = 3, m2Price = 499, m3Qty = 5, m3Price = 799, qualifyingPriceLimit = 255;
    if (progressSection) {
      m1Qty = parseInt(progressSection.getAttribute('data-m1-qty'), 10) || 2;
      m1Price = parseInt(progressSection.getAttribute('data-m1-price'), 10) || 349;
      m2Qty = parseInt(progressSection.getAttribute('data-m2-qty'), 10) || 3;
      m2Price = parseInt(progressSection.getAttribute('data-m2-price'), 10) || 499;
      m3Qty = parseInt(progressSection.getAttribute('data-m3-qty'), 10) || 5;
      m3Price = parseInt(progressSection.getAttribute('data-m3-price'), 10) || 799;
      qualifyingPriceLimit = parseInt(progressSection.getAttribute('data-qualifying-limit'), 10) || 255;
    }

    const qualifyingPriceLimitCents = qualifyingPriceLimit * 100;

    // Total quantity of all items in cart
    let totalQty = 0;
    // MRP sum of all items in cart
    let mrpTotal = 0;
    // Current price subtotal of all items in cart
    let currentTotal = 0;

    cart.items.forEach(function (item) {
      totalQty += item.quantity;

      // Find compare-at price or default to price
      const itemWrapper = document.getElementById('sr-cart-item-wrapper-' + item.key);
      let comparePrice = item.price;
      if (itemWrapper) {
        const rawCompare = itemWrapper.getAttribute('data-compare-at-price');
        const rawPrice = itemWrapper.getAttribute('data-price');
        
        if (rawCompare) {
          comparePrice = parseInt(rawCompare, 10);
        }
        if (rawPrice) {
          item.price = parseInt(rawPrice, 10);
        }
      }
      
      mrpTotal += (comparePrice * item.quantity);
      currentTotal += (item.price * item.quantity);
    });

    // Milestone and Combo Discount Calculations (Strictly for items under dynamic qualifyingPriceLimit)
    const qualifyingItems = cart.items.filter(function(item) {
      const isMagicEraser = (item.handle && item.handle.includes('magic-eraser')) || 
                            (item.url && item.url.includes('magic-eraser')) ||
                            (item.product_title && item.product_title.toLowerCase().includes('magic eraser')) ||
                            (item.title && item.title.toLowerCase().includes('magic eraser'));
      return item.price <= qualifyingPriceLimitCents && !isMagicEraser;
    });

    let qualifyingPrices = [];
    qualifyingItems.forEach(function(item) {
      for (let i = 0; i < item.quantity; i++) {
        qualifyingPrices.push(item.price);
      }
    });

    // Sort descending to discount the most expensive items first
    qualifyingPrices.sort(function(a, b) {
      return b - a;
    });

    const qualifyingQty = qualifyingPrices.length;

    // Progress Mapping for Progress Bar Track (Dynamic interpolation):
    // Milestone 1 (m1Qty) at 20%
    // Milestone 2 (m2Qty) at 55%
    // Milestone 3 (m3Qty) at 90%
    let progressVal = 0;
    if (qualifyingQty === 0) {
      progressVal = 0;
    } else if (qualifyingQty < m1Qty) {
      progressVal = (qualifyingQty / m1Qty) * 20;
    } else if (qualifyingQty === m1Qty) {
      progressVal = 20;
    } else if (qualifyingQty < m2Qty) {
      progressVal = 20 + ((qualifyingQty - m1Qty) / (m2Qty - m1Qty)) * (55 - 20);
    } else if (qualifyingQty === m2Qty) {
      progressVal = 55;
    } else if (qualifyingQty < m3Qty) {
      progressVal = 55 + ((qualifyingQty - m2Qty) / (m3Qty - m2Qty)) * (90 - 55);
    } else {
      progressVal = 90;
    }

    // Update progress bar UI
    const progressBar = document.getElementById('progress');
    if (progressBar) {
      progressBar.style.width = progressVal + '%';
    }

    // Update milestone badge icons and unlock active states
    const m1 = document.getElementById('badge-milestone-1');
    const m2 = document.getElementById('badge-milestone-2');
    const m3 = document.getElementById('badge-milestone-3');

    if (m1) {
      if (qualifyingQty >= m1Qty) {
        m1.classList.remove('greyscale');
        const parent = m1.closest('.milestone');
        if (parent) {
          parent.setAttribute('data-confetti-shown', 'true');
          parent.classList.remove('greyscale');
        }
      } else {
        m1.classList.add('greyscale');
        const parent = m1.closest('.milestone');
        if (parent) {
          parent.setAttribute('data-confetti-shown', 'false');
          parent.classList.add('greyscale');
        }
      }
    }
    if (m2) {
      if (qualifyingQty >= m2Qty) {
        m2.classList.remove('greyscale');
        const parent = m2.closest('.milestone');
        if (parent) {
          parent.setAttribute('data-confetti-shown', 'true');
          parent.classList.remove('greyscale');
        }
      } else {
        m2.classList.add('greyscale');
        const parent = m2.closest('.milestone');
        if (parent) {
          parent.setAttribute('data-confetti-shown', 'false');
          parent.classList.add('greyscale');
        }
      }
    }
    if (m3) {
      if (qualifyingQty >= m3Qty) {
        m3.classList.remove('greyscale');
        const parent = m3.closest('.milestone');
        if (parent) {
          parent.setAttribute('data-confetti-shown', 'true');
          parent.classList.remove('greyscale');
        }
      } else {
        m3.classList.add('greyscale');
        const parent = m3.closest('.milestone');
        if (parent) {
          parent.setAttribute('data-confetti-shown', 'false');
          parent.classList.add('greyscale');
        }
      }
    }

    // Update progress bar instruction sub-heading
    const subHeading = document.querySelector('.progress-bar-sub-heading-top');
    if (subHeading) {
      if (qualifyingQty === 0) {
        subHeading.innerHTML = `Add ${m1Qty} single products to unlock the BUY${m1Qty}AT${m1Price} offer!`;
      } else if (qualifyingQty < m1Qty) {
        const remaining = m1Qty - qualifyingQty;
        subHeading.innerHTML = `Add ${remaining} more single product(s) to unlock the BUY${m1Qty}AT${m1Price} offer!`;
      } else if (qualifyingQty === m1Qty) {
        subHeading.innerHTML = `Add 1 more single product to unlock the BUY${m2Qty}AT${m2Price} offer!`;
      } else if (qualifyingQty < m3Qty) {
        const remaining = m3Qty - qualifyingQty;
        subHeading.innerHTML = `Add ${remaining} more single product(s) to unlock the BUY${m3Qty}AT${m3Price} offer!`;
      } else {
        subHeading.innerHTML = `🎉 Congratulations! You have unlocked the maximum BUY${m3Qty}AT${m3Price} discount!`;
      }
    }

    // Dynamic auto discount calculation:
    let autoDiscountAmt = 0;
    let autoDiscountName = "";

    if (qualifyingQty >= m3Qty) {
      autoDiscountName = `BUY${m3Qty}AT${m3Price}`;
      const topSum = qualifyingPrices.slice(0, m3Qty).reduce(function(sum, p) { return sum + p; }, 0);
      autoDiscountAmt = topSum - (m3Price * 100);
    } else if (qualifyingQty >= m2Qty) {
      autoDiscountName = `BUY${m2Qty}AT${m2Price}`;
      const topSum = qualifyingPrices.slice(0, m2Qty).reduce(function(sum, p) { return sum + p; }, 0);
      autoDiscountAmt = topSum - (m2Price * 100);
    } else if (qualifyingQty >= m1Qty) {
      autoDiscountName = `BUY${m1Qty}AT${m1Price}`;
      const topSum = qualifyingPrices.slice(0, m1Qty).reduce(function(sum, p) { return sum + p; }, 0);
      autoDiscountAmt = topSum - (m1Price * 100);
    }

    if (autoDiscountAmt < 0) autoDiscountAmt = 0;

    // Apply Coupon persistence values if coupon applied
    let couponDiscountAmt = 0;
    const couponVal = localStorage.getItem('couponDiscountVal');
    if (couponVal) {
      couponDiscountAmt = parseInt(couponVal, 10);
    }

    // Final price calculation
    const dealPriceVal = currentTotal - autoDiscountAmt;
    const finalToPay = dealPriceVal - couponDiscountAmt;
    let totalSavingsVal = (mrpTotal - currentTotal) + autoDiscountAmt + couponDiscountAmt;
    if (totalSavingsVal < 0) totalSavingsVal = 0;

    // Save in session storage to verify in templates
    sessionStorage.setItem('smart_cart_total', finalToPay);

    // Update quantities and price elements in Header
    const headerQty = document.getElementById('sr-cart-header-quantity');
    if (headerQty) headerQty.innerText = `(${totalQty})`;

    // Update savings alert badge (only progress combined offer badge is visible now)
    const progressOfferBadge = document.getElementById('progress-combined-offer-badge');
    if (progressOfferBadge) {
      if (totalSavingsVal > 0) {
        progressOfferBadge.classList.remove('hidden');
        progressOfferBadge.innerHTML = `🎉 You're saving <b>${formatINRInt(totalSavingsVal)}</b> 🎉!`;
      } else {
        progressOfferBadge.classList.add('hidden');
      }
    }

    // Update estimated totals in footer
    const footerOriginalPrice = document.querySelector('.summary-original-price');
    const footerTotalPrice = document.querySelector('.total-price');
    if (footerOriginalPrice) {
      if (totalSavingsVal > 0) {
        footerOriginalPrice.classList.remove('hidden');
        footerOriginalPrice.innerText = formatINRInt(mrpTotal);
      } else {
        footerOriginalPrice.classList.add('hidden');
      }
    }
    if (footerTotalPrice) footerTotalPrice.innerText = formatINRInt(finalToPay);

    // Update Bill summary collapsible table details
    const srSubTotal = document.querySelector('.sr-sub-total');
    const mrpDiscount = document.getElementById('sr-cart-discount-code-discount-mrp');

    if (srSubTotal) srSubTotal.innerText = formatINRInt(mrpTotal);
    if (mrpDiscount) mrpDiscount.innerText = `-${formatINRInt(mrpTotal - currentTotal)}`;

    // Combined Auto Milestone discount and Manual Coupon discount row
    const couponRow = document.getElementById('sr-bill-coupon-row');
    const couponLabel = document.getElementById('sr-bill-coupon-label');
    const couponValue = document.getElementById('sr-bill-coupon-discount-value');

    if (couponRow && couponValue) {
      const totalExtraDiscount = autoDiscountAmt + couponDiscountAmt;
      if (totalExtraDiscount > 0) {
        couponRow.classList.remove('hidden');
        if (autoDiscountAmt > 0 && couponDiscountAmt > 0) {
          if (couponLabel) couponLabel.innerText = 'Discount & Coupon';
        } else if (autoDiscountAmt > 0) {
          if (couponLabel) couponLabel.innerText = `Auto discount (${autoDiscountName})`;
        } else {
          if (couponLabel) couponLabel.innerText = 'Coupon discount';
        }
        couponValue.innerText = `-${formatINRInt(totalExtraDiscount)}`;
      } else {
        couponRow.classList.add('hidden');
      }
    }

    // Update grand total in detailed breakdown
    const grandTotalEl = document.querySelector('.sr-grand-total');
    if (grandTotalEl) grandTotalEl.innerText = formatINRInt(finalToPay);

    // Update shipping text based on milestone (free shipping unlocked at milestone 1)
    const shippingText = document.getElementById('sr-cart-shipping-charges-text');
    if (shippingText) {
      if (qualifyingQty >= m1Qty) {
        shippingText.innerText = 'FREE';
        shippingText.style.color = '#008060';
        shippingText.classList.add('free');
      } else {
        shippingText.innerText = 'To be calculated';
        shippingText.style.color = '';
        shippingText.classList.remove('free');
      }
    }

    // Update micro savings line under estimated total
    const estimatedSavingsSub = document.getElementById('sr-estimated-savings-sub');
    const estimatedSavingsAmt = document.querySelector('.sr-estimated-savings-amt');
    if (estimatedSavingsSub && estimatedSavingsAmt) {
      if (totalSavingsVal > 0) {
        estimatedSavingsSub.classList.remove('hidden');
        estimatedSavingsAmt.innerText = formatINRInt(totalSavingsVal);
      } else {
        estimatedSavingsSub.classList.add('hidden');
      }
    }

    // Update green Shopflo savings strip
    const savingsStrip = document.getElementById('sr-shopflo-savings-strip');
    const savingsStripAmt = document.querySelector('.sr-savings-strip-amt');
    const savingsStripPercent = document.querySelector('.sr-savings-strip-percent');
    if (savingsStrip && savingsStripAmt && savingsStripPercent) {
      if (totalSavingsVal > 0) {
        savingsStrip.classList.remove('hidden');
        savingsStripAmt.innerText = formatINRInt(totalSavingsVal);
        
        // Calculate percent: (totalSavingsVal / mrpTotal) * 100
        const percent = mrpTotal > 0 ? Math.round((totalSavingsVal / mrpTotal) * 100) : 0;
        savingsStripPercent.innerText = percent + '%';
      } else {
        savingsStrip.classList.add('hidden');
      }
    }
  }

  // Hook quantity button actions (+ and -) via event delegation on document
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.mini-cart-qty-btn');
    if (!btn) return;

    e.preventDefault();
    const actionsWrapper = btn.closest('.mini-cart-item-actions');
    const variantId = btn.getAttribute('data-id');
    const operation = btn.getAttribute('data-operation-type');

    if (actionsWrapper.classList.contains('loading')) return;

    // Get current value
    const input = actionsWrapper.querySelector('.mini-cart-item-qty');
    let qty = parseInt(input.value, 10);
    if (isNaN(qty)) qty = 1;

    // Compute new quantity
    let newQty = qty;
    if (operation === 'add') {
      newQty = qty + 1;
    } else if (operation === 'sub') {
      newQty = qty - 1;
    }

    if (newQty < 1) {
      // Trigger delete confirmation via standard delete button
      const wrapper = actionsWrapper.closest('.mini-cart-item-wrapper');
      const deleteBtn = wrapper ? wrapper.querySelector('.mini-cart-item-delete') : null;
      if (deleteBtn) {
        deleteBtn.click();
      } else {
        updateCartItemQuantity(variantId, 0);
      }
      return;
    }

    // Trigger update
    updateCartItemQuantity(variantId, newQty, actionsWrapper);
  });

  // AJAX update function
  function updateCartItemQuantity(variantId, quantity, actionsWrapper) {
    if (actionsWrapper) {
      actionsWrapper.classList.add('loading');
    } else {
      const loader = document.querySelector('.full-page-loader-container');
      if (loader) loader.style.display = 'flex';
    }

    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(data => {
      // Reload cart section to update drawer markup and bindings
      document.body.dispatchEvent(new Event('update:miniCart'));
    })
    .catch(err => {
      console.error(err);
      window.location.reload();
    });
  }



  // Initialize and attach to event listeners
  function initSmartCartActions() {
    // Initial State recalculation
    recalculateCartSmartState();

    // Re-fill coupon field if coupon exists in local storage
    const storedCoupon = localStorage.getItem('storedDiscount');
    const couponInput = document.querySelector('.sr-cart-text-input-box-main');
    if (storedCoupon && couponInput && !couponInput.value) {
      couponInput.value = storedCoupon;
      window.handleCouponInputChange(couponInput.id, 'sr-cart-coupon-input-action-main');
    }
  }

  // Attach to Alothemes minicart load lifecycle
  document.body.addEventListener('contentUpdated', function () {
    initSmartCartActions();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initSmartCartActions();
  });

  // Re-run whenever dynamic changes are broadcasted
  document.body.addEventListener('drawer:Minicart', function () {
    if (window.location.pathname.includes('/cart')) {
      window.location.reload();
      return;
    }
    setTimeout(initSmartCartActions, 100);
  });

})();
